// extracted by mini-css-extract-plugin
export default {"arrow":"arrow_arrow__JSTFn","icon_delete":"arrow_icon_delete__URh8-"};